import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

//
import { resetPassword } from "../../redux/features/user/actions";

//
import { Form, Button, Spinner } from "react-bootstrap";

//
import PasswordStrengthMeter from "../../components/general/PasswordStrengthMeter";
import ImageBox from "../../components/general/ImageBox";

//
import Key from "../../assets/img/user-images/key.png";

//
import { Formik } from "formik";
import * as yup from "yup";
import GoogleRecaptchaModal from "../../components/auth/GoogleRecaptchaModal";

//
const schema = yup.object().shape({
  password: yup.string().required(),
  password_confirmation: yup
    .string()
    .required()
    .oneOf([yup.ref("password"), null], "Passwords must match"),
});

const ResetPassword = () => {
  const navigate = useNavigate();
  const { token } = useParams();
  const [show, setShow] = useState(false);

  const [loading, setLoading] = useState(false);
  const [score, setScore] = useState(0);
  const [password, setPassword] = useState("");

  const [passwordCanSee, setPasswordCanSee] = useState(false);
  const [passwordConfirmationCanSee, setPasswordConfirmationCanSee] =
    useState(false);

  const [userData, setUserData] = useState({
    password: "",
    password_confirmation: "",
  });

  /**
   * Reset Password
   */
  const reset_password = (e) => {
    // close modal
    setShow(false);

    // start loading
    setLoading(true);

    // variables
    let content = { ...userData };
    content.recaptcha = e

    // request
    resetPassword({ content, token }).then((res) => {
      if (res) {
        setLoading(false);
        setTimeout(() => {
          navigate("/auth/login");
        }, 2000);
      } else {
        setLoading(false);
      }
    });
  };

  const saveData = (e) => {
    let user_data = { ...userData };
    user_data.password = e.password;
    user_data.password_confirmation = e.password_confirmation;
    setUserData(user_data);
    setShow(true);
  };

  return (
    <>
      <GoogleRecaptchaModal
        show={show}
        setShow={(status) => setShow(status)}
        action={reset_password}
      />

      <div>
        <ImageBox src={Key} />
        <h4>Reset Password</h4>

        <p>Please enter your new password to continue the the next step</p>

        <Formik
          validationSchema={schema}
          onSubmit={saveData}
          initialValues={{
            password: "",
            password_confirmation: "",
          }}
        >
          {({ handleSubmit, handleChange, touched, errors }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {/* New */}
              <Form.Group className="form-group" controlId="validationFormik0">
                <Form.Label>New Password</Form.Label>
                <div className="input-holder right">
                  <Form.Control
                    type={passwordCanSee ? "text" : "password"}
                    name="password"
                    placeholder="Type here..."
                    className="form-control"
                    onChange={(e) => {
                      handleChange(e);
                      setPassword(e.target.value);
                    }}
                    autoComplete="off"
                    isInvalid={
                      touched.password && (!!errors.password || score < 3)
                    }
                  />
                  <i
                    className={`las pointer ${
                      passwordCanSee ? "la-eye" : "la-eye-slash"
                    }`}
                    onClick={() => setPasswordCanSee(!passwordCanSee)}
                  ></i>
                </div>
                <PasswordStrengthMeter
                  password={password}
                  action={(score) => setScore(score)}
                />
              </Form.Group>

              {/* Confirm */}
              <Form.Group className="form-group" controlId="validationFormik2">
                <Form.Label>Confirm Password</Form.Label>
                <div className="input-holder right">
                  <Form.Control
                    type={passwordConfirmationCanSee ? "text" : "password"}
                    name="password_confirmation"
                    placeholder="Type here..."
                    className="form-control"
                    onChange={handleChange}
                    autoComplete="off"
                    isInvalid={
                      touched.password_confirmation &&
                      !!errors.password_confirmation
                    }
                  />
                  <i
                    className={`las pointer ${
                      passwordConfirmationCanSee ? "la-eye" : "la-eye-slash"
                    }`}
                    onClick={() =>
                      setPasswordConfirmationCanSee(!passwordConfirmationCanSee)
                    }
                  ></i>
                </div>
              </Form.Group>

              <Button size="lg" type="submit" variant="info" className="w-100">
                Confirm
                {loading && (
                  <div className="spinner-holder">
                    <Spinner animation="border" variant="white" size="sm" />
                  </div>
                )}
              </Button>
            </Form>
          )}
        </Formik>
      </div>
    </>
  );
};
export default ResetPassword;
